import { useEffect } from 'react';

/**
 * Resizes a textarea to fit its content. Caller renders the textarea with
 * `rows={1}` and a CSS `min-height` / `max-height`; this hook adjusts
 * `style.height` between those bounds as the value changes.
 *
 * Extracted from the main app's
 * `common/utilities/autosize-textarea/autosize-textarea.util.ts`.
 */
export function useAutosizeTextArea(
  textArea: HTMLTextAreaElement | null,
  value: string,
) {
  useEffect(() => {
    if (!textArea) return;
    textArea.style.height = '0px';
    textArea.style.height = `${textArea.scrollHeight}px`;
  }, [textArea, value]);
}
